import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { WishlistProvider } from "@/context/WishlistContext";
import { I18nProvider } from "@/context/I18nContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import ProductPage from "@/pages/ProductPage";
import Checkout from "@/pages/Checkout";
import OrderConfirmation from "@/pages/OrderConfirmation";
import Admin from "@/pages/Admin";
import Wishlist from "@/pages/Wishlist";

function App() {
    return (
        <div className="App">
            <I18nProvider>
                <WishlistProvider>
                    <CartProvider>
                        <BrowserRouter>
                            <Routes>
                                <Route element={<Layout />}>
                                    <Route path="/" element={<Home />} />
                                    <Route path="/collection" element={<Catalog />} />
                                    <Route path="/product/:id" element={<ProductPage />} />
                                    <Route path="/wishlist" element={<Wishlist />} />
                                    <Route path="/checkout" element={<Checkout />} />
                                    <Route
                                        path="/order/:orderNumber"
                                        element={<OrderConfirmation />}
                                    />
                                    <Route path="/admin" element={<Admin />} />
                                </Route>
                            </Routes>
                        </BrowserRouter>
                        <Toaster
                            position="bottom-right"
                            theme="dark"
                            toastOptions={{
                                style: {
                                    background: "#0a0a0a",
                                    border: "1px solid rgba(255,255,255,0.15)",
                                    color: "#ffffff",
                                    borderRadius: "0",
                                },
                            }}
                        />
                    </CartProvider>
                </WishlistProvider>
            </I18nProvider>
        </div>
    );
}

export default App;
